/**
 * Query-key factory for profile server state. Sharing these keys between the
 * hooks that subscribe (`useProfile`) and the service that writes
 * the cache keeps reads and writes pointed at the same cache entries.
 *
 * These are the keys to the cache `stores`
 */
export const profileKeys = {
  emailVerification: ["email-verification"] as const,
  experiences: ["experiences"] as const,
  phoneVerification: ["phone-verification"] as const,
  profile: ["profile"] as const, // store will be in the form of ProfileData (NormalizedProfile | undefined | null)
};
